import { SingleAccountExportPayloadProps } from './SingleAccountExportSelector';

export const getNewAccountsPayload = (
  accountsPayload: Array<SingleAccountExportPayloadProps>,
  newSingleAccountPayload: SingleAccountExportPayloadProps
): Array<SingleAccountExportPayloadProps> => {
  const isAccountSelected = accountsPayload.find(
    ({ id }) => id === newSingleAccountPayload.id
  );

  const newPayload = isAccountSelected
    ? accountsPayload.map((accountPayload) => {
        return accountPayload.id === newSingleAccountPayload.id
          ? newSingleAccountPayload
          : accountPayload;
      })
    : [...accountsPayload, newSingleAccountPayload];

  return newPayload.filter(({ excel, pdf }) => excel || pdf);
};

export default {
  getNewAccountsPayload,
};
